var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3575_4683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.599 3.72014C13.599 4.02617 13.599 4.3356 13.599 4.64163C13.5491 4.67903 13.5591 4.74024 13.5557 4.78784C13.4593 5.54612 13.1666 6.22619 12.7575 6.85865C12.1921 7.73594 11.467 8.46361 10.712 9.16408C9.62774 10.1706 8.50022 11.1227 7.39267 12.1054C7.32615 12.1632 7.2563 12.221 7.1798 12.2652C6.87381 12.4352 6.53789 12.3876 6.2452 12.136C5.79951 11.7483 5.35716 11.3607 4.91813 10.9697C3.96356 10.1298 2.98905 9.30689 2.09768 8.3922C1.41918 7.69513 0.787237 6.95386 0.404747 6.03577C-0.227192 4.50901 -0.134064 3.02647 0.763955 1.63233C1.58548 0.3606 3.15535 -0.254862 4.60881 0.0987738C5.49352 0.312995 6.17535 0.843448 6.72082 1.57112C6.78401 1.65613 6.81394 1.66973 6.88379 1.57452C7.17648 1.16648 7.53236 0.823046 7.95144 0.551019C8.72972 0.0477687 9.57785 -0.0984459 10.4825 0.0681707C11.1643 0.193983 11.7664 0.493213 12.2752 0.969261C12.9238 1.57112 13.3163 2.326 13.5025 3.19648C13.5358 3.3699 13.5258 3.55352 13.599 3.72014Z",
    fill: "#AAA4C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3575_4683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6,
    height: 12.3636,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourties);
export default __webpack_public_path__ + "static/media/favourties.87b6914dba28e31cecee9cfaedf8e328.svg";
export { ForwardRef as ReactComponent };